module.exports = __webpack_public_path__ + "img/en_banner.28258a6.gif";